export function updateConfig(value){
  return {
    type: '@config/UPDATE_CONFIG',
    payload: value
  };
}